import { render, staticRenderFns } from "./FoodPublicLabel.vue?vue&type=template&id=5497f295&scoped=true&"
import script from "./FoodPublicLabel.vue?vue&type=script&lang=js&"
export * from "./FoodPublicLabel.vue?vue&type=script&lang=js&"
import style0 from "./FoodPublicLabel.vue?vue&type=style&index=0&id=5497f295&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5497f295",
  null
  
)

export default component.exports